import Vue from 'vue'
import { configStore } from '@commons/store/config.store'

export function setCSRFToken() {
  Vue.http.interceptors.push(function(request) {
    const authenticityToken = configStore.state.authenticityToken
    request.headers.set('X-CSRF-TOKEN', authenticityToken);
  })
}

export function checkResponseStatus() {
  Vue.http.interceptors.push((request, next) => {
    next(response => {
      if (response.status == 403 || response.status == 404 || response.status == 422) {
        window.location.href = '#/'
      }
    })
  })
}
